import fileUploadConst from '@/constants/fileUploadConst';

export default {
    methods: {
        inputFilesFilterWithAudio (newFile, oldFile, prevent) {
            this.inputFilesFilter(newFile, oldFile, prevent, true);
        },
        inputFilesFilter (newFile, oldFile, prevent, allowAudio = false) {
            if (newFile && !oldFile) {
                const regexWithAudio = /\.(jpeg|jpg|tiff|png|pdf|mp3)$/i;
                const regex = /\.(jpeg|jpg|tiff|png|pdf)$/i;

                const notAudio = allowAudio && !regexWithAudio.test(newFile.name);
                const notOther = allowAudio === false && !regex.test(newFile.name);

                if (notAudio || notOther) {
                    this.error = this.$t('errors.file_format_error');
                    return prevent();
                }
                if (newFile.size > this.maxSize) {
                    this.error = this.$t('errors.file_size_error');
                    return prevent();
                }
                newFile.blob = '';
                const URL = window.URL || window.webkitURL;
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file);
                }
                if (/Edge/.test(navigator.userAgent)) {
                    window.navigator.msSaveOrOpenBlob(newFile.file, newFile.name);
                }
            }
            const length = (this.files && this.files.length) || (this.file && this.file.length);
            if (this.maxQuantity !== 0 && length === this.maxQuantity) {
                this.error = this.$t('errors.file_quantity_error');
            }
        }
    },
    computed: {
        maxSize () {
            return fileUploadConst.MAX_SIZE;
        },
        maxQuantity () {
            return fileUploadConst.MAX_QUANTITY;
        },
        accept () {
            return fileUploadConst.POST_MEETING_ACCEPT;
        },
        acceptInitialConsent () {
            return fileUploadConst.INITIAL_CONSENT_ACCEPT;
        }
    }
};
